//This file contain all routes defined as constants

const ROUTES = {
    DEFAULT: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    HOME: '/home',
    ADMIN: '/admin',
    LOGOUT: '/logout',
    BOOK_SHOW: '/book/:id',
    SEARCH_BOOK: '/searchBook',
    GOOGLE_BOOK: '/GoogleBook',
    NOT_FOUND: '/404',
    USER_PROFILE: '/profile',
    LIBRARY: '/library',
    CREATE_BOOK: '/createBook',
    EDIT_BOOK: '/editBook/:id',
    AUTHOR_SHOW: '/author/:id',
    ADMIN_GENRES: '/admin/genres',
    ADMIN_AUTHORS: '/admin/authors',
    ADMIN_BOOKS: '/admin/books',
    ADMIN_USERS: '/admin/users',
}

export default ROUTES;